import axiosInstance from "./httpInterceptor";

export const productShowdownService = {
  /**
   * Fetch Terumo anchor products for the "My Product" selector.
   * Returns [{ productFamily, category }]
   */
  getAnchors: () =>
    axiosInstance.get("/v1/product-showdown/anchors"),

  /**
   * Fetch competitor products valid for a given anchor.
   * Returns [{ productFamily, companyName, competitorId, documentSource, available }]
   * available=false means the device is PENDING (no document URL yet).
   * @param {string} anchorFamily - e.g. "FRED" or "SOFIA Plus"
   */
  getCompetitorsForAnchor: (anchorFamily) =>
    axiosInstance.get(`/v1/product-showdown/anchors/${encodeURIComponent(anchorFamily)}/competitors`),

  /**
   * Get or generate a comparison for an anchor + competitor product pair.
   * First request for a new pair takes ~30s (LLM generation).
   * Subsequent requests are instant (served from MongoDB cache).
   * @param {string} anchorFamily     - e.g. "SOFIA Plus"
   * @param {string} competitorFamily - e.g. "ACE Reperfusion Catheter"
   */
  getComparison: (anchorFamily, competitorFamily) =>
    axiosInstance.get("/v1/product-showdown/comparison", {
      params: { anchorFamily, competitorFamily },
      timeout: 90000, // 90s — LLM generation can take up to 45s
    }),

  // ── Admin endpoints ──────────────────────────────────────────────────────

  /** Trigger full scrape + PDF extraction pipeline (ADMIN). */
  runScraper: () =>
    axiosInstance.post("/v1/product-showdown/scraper/run"),

  /** Trigger PDF extraction only (ADMIN). */
  extractPdfs: () =>
    axiosInstance.post("/v1/product-showdown/extract-pdfs"),
};
